import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "trigger", "overlay"]

  connect() {
    this._onKeydown = this._handleKeydown.bind(this)
    this._watchFooter()
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    if (this._footerObserver) this._footerObserver.disconnect()
  }

  // Hide the floating trigger while the footer is in view so it never sits on
  // top of footer content. Visible everywhere else, all screen sizes.
  _watchFooter() {
    const footer = document.querySelector("footer")
    if (!footer || !("IntersectionObserver" in window) || !this.hasTriggerTarget) return

    this._footerObserver = new IntersectionObserver((entries) => {
      const nearFooter = entries[0].isIntersecting
      this.triggerTarget.classList.toggle("hidden", nearFooter)
      if (nearFooter) this.close()
    })
    this._footerObserver.observe(footer)
  }

  open() {
    this.panelTarget.classList.remove("scale-95", "opacity-0", "pointer-events-none")
    this.panelTarget.classList.add("scale-100", "opacity-100")
    this.panelTarget.setAttribute("aria-hidden", "false")
    this.backdropTarget.classList.remove("hidden")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
      this.overlayTarget.classList.add("opacity-100")
    }
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.panelTarget.classList.add("scale-95", "opacity-0", "pointer-events-none")
    this.panelTarget.classList.remove("scale-100", "opacity-100")
    this.panelTarget.setAttribute("aria-hidden", "true")
    this.backdropTarget.classList.add("hidden")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
      this.overlayTarget.classList.remove("opacity-100")
    }
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle() {
    const isOpen = this.panelTarget.getAttribute("aria-hidden") === "false"
    isOpen ? this.close() : this.open()
  }

  _handleKeydown(e) {
    if (e.key === "Escape") this.close()
  }
}
